<template>
	<b-card header-tag="header">
		<template #header style="position: relative">
			<b-row>
				<b-col>
					<h4 @click="$router.push('/')"><b>Главное меню</b></h4>
				</b-col>
				<b-col @click="$router.push('/')">
					<img src="../../../../public/img/duty.png"
						style="width: 195px; position: absolute; top: -10px; right: 25%" alt="">
				</b-col>
				<b-col align="right">
					<h4 class="mr-2"><b>@ {{ username }}</b></h4>
				</b-col>
				<b-col @click="logout" cols="1">
					<b-button size="sm">
						<i style="font-size: 15px" class="fas fa-sign-out-alt text-danger mr-1" /> <b>Выйти</b>
					</b-button>
				</b-col>
			</b-row>
		</template>
		<b-row>
			<b-col>
				<b-row class="mt-3">
					<b-col cols="5" align="center">
						<h4><b>{{ $t('promo-to-product.department') }}:</b></h4>
					</b-col>
					<b-col>
						<h4>{{ fiscalData.departmentName }}</h4>
					</b-col>
				</b-row>
			</b-col>
			<b-col>
				<b-row class="mt-3">
					<b-col cols="5" align="center">
						<h4><b>{{ $t('kassa.nomer') }}:</b></h4>
					</b-col>
					<b-col>
						<h4>{{ fiscalData.name }}</h4>
					</b-col>
				</b-row>
			</b-col>
			<b-col cols="4">
				<div class="mt-3 d-flex flex-row justify-content-around align-items-center gap-4">
					<b-button style="width: 80px" v-if="isNew === 'true'"
						class="d-flex flex-column text-center justify-content-center align-items-center text-white"
						@click="confirmEndTerminal = true" variant="warning">
						<i class="fa fa-credit-card mb-1" />
						Терминал
					</b-button>
				</div>
			</b-col>
		</b-row>
		<b-row class="mt-5">
			<b-col>
				<b-button @click="$router.push('/point-of-sale/transfer-income')" style="width: 100%; padding: 40px">
					<i style="font-size: 40px" class="fa fa-cloud-download text-info mb-3" />
					<h5><b>Приход</b></h5>
				</b-button>
			</b-col>
			<b-col>
				<b-button @click="$router.push('/warehouse-management/warehouses-for-pos')"
					style="width: 100%; padding: 40px">
					<i style="font-size: 40px" class="fa fa-home text-primary mb-3" />
					<h5><b>Остатка</b></h5>
				</b-button>
			</b-col>
			<b-col>
				<b-button
					@click="$router.push(`/point-of-sale/sales-for-seller/${fiscalData.departmentId}/${fiscalData.id}`)"
					style="width: 100%; padding: 40px">
					<i style="font-size: 40px" class="fa fa-list text-dark mb-3" />
					<h5><b>Список Продаж</b></h5>
				</b-button>
			</b-col>
			<b-col>
				<b-button @click="$router.push(`/point-of-sale/kpi/${fiscalData.departmentId}`)"
					style="width: 100%; padding: 40px">
					<i style="font-size: 40px" class="fa fa-list-alt text-dark mb-3" />
					<h5><b>KPI</b></h5>
				</b-button>
			</b-col>
		</b-row>
		<b-row class="mt-5">
			<b-col>
				<b-button @click="xreportOpen" style="width: 100%; padding: 40px">
					<i style="font-size: 40px" class="fa fa-close text-success mb-3" />
					<h5><b>Х-отчёт</b></h5>
				</b-button>
			</b-col>
			<b-col>
				<b-button
					@click="$can('perm', 'return') ? returnComponentModal = true : $vs.notify({ title: 'У вас нет доступа !', color: 'danger', icon: 'close', position: 'top-right' })"
					style="width: 100%; padding: 40px">
					<i style="font-size: 40px" class="fa fa-undo text-success mb-3" />
					<h5><b>Возврат</b></h5>
				</b-button>
			</b-col>
			<b-col>
				<b-button @click="toPos" style="width: 100%; padding: 40px">
					<i style="font-size: 40px" class="fa fa-plus-circle text-primary mb-3" />
					<h5><b>Начать Продажу</b></h5>
				</b-button>
			</b-col>
			<b-col>
				<b-button @click="confirmEndSession = true" style="width: 100%; padding: 40px">
					<p style="font-size: 35px" class="text-danger mb-1"><b>Z</b></p>
					<h5><b>Z-отчёт</b></h5>
				</b-button>
			</b-col>
		</b-row>

		<b-modal centered v-model="confirmEndTerminal" @ok="humoClose"
			@cancel="confirmEndTerminal = !confirmEndTerminal" ok-title="Да" cancel-title="Отмена">
			Вы хотите закрыть день на терминале. Вы уверены?
		</b-modal>

		<!-- Z-REPORT END SESSION MODAL -->
		<b-modal v-model="confirmEndSession" @ok="closeAndPrintZReport" @cancel="confirmEndSession = !confirmEndSession"
			ok-title="Да" cancel-title="Отмена">
			<h4>{{ $t('zOtchet.title') }}</h4>
		</b-modal>

		<!-- Z-REPORT VIEW MODAL -->
		<b-modal v-model="zreport" size="lg" hide-footer :no-close-on-esc="true" :no-close-on-backdrop="true"
			hide-header class="body-padding-0">
			<x-and-z-report v-if="zreport" is-z-report @close="closeZreport"></x-and-z-report>
		</b-modal>

		<!-- X-REPORT VIEW MODAL -->
		<b-modal v-model="xreport" size="lg" hide-footer hide-header :no-close-on-esc="true"
			:no-close-on-backdrop="true" class="body-padding-0">
			<x-and-z-report v-if="xreport" @close="closeXreport"></x-and-z-report>
		</b-modal>

		<!-- RETURN MODAL -->
		<b-modal v-model="returnComponentModal" size="lg" hide-footer hide-header :no-close-on-esc="true"
			:no-close-on-backdrop="true">
			<template>
				<return-component :mode="'retail'" :show-return-modal="returnComponentModal"
					@close="closeReturnModal" />
			</template>
		</b-modal>
	</b-card>
</template>

<script>
import Multiselect from 'vue-multiselect'
import XAndZReport from "@/views/point-of-sale/pos/components/Xreport/XAndZReport";
import ReturnComponent from "@/views/return-component/ReturnComponent";
import { mapActions, mapGetters, mapState } from 'vuex'
import { TokenService } from "../../../services/storage.service";
import FBoxService from "../../../services/fbox.service";
import PosService from "../../../services/pos.service";

export default {
	name: "before_pos",
	components: { Multiselect, XAndZReport, ReturnComponent },
	data() {
		return {
			isNew: localStorage.getItem('is_new'),
			confirmEndTerminal: false,
			selectedDepForSearch: null,
			cashboxList: [],
			selectedDep: null,
			refInputNotFilled: false,
			modalForAdding: false,
			cashboxnumber: '',
			show: false,
			errorShow: false,
			cashboxId: null,
			savedCashboxId: null,
			confirmEndSession: false,
			zreport: false,
			xreport: false,
			returnComponentModal: false,
			fiscalData: {}
		}
	},
	computed: {
		...mapGetters('departments', ['myDepartments']),
		...mapState("zetReport", ["currentReport"]),
		username() {
			return TokenService.getUserName();
		}
	},
	watch: {
		'fiscalData': {
			handler(d) {
				localStorage.setItem('cash_id', d.id)
				localStorage.setItem('dep_id', d.departmentId)
				localStorage.setItem('dep_name', d.departmentName)
				localStorage.setItem('ip_address', d.ipAddress)
				localStorage.setItem('cash_number', d.name)
				localStorage.setItem('is_bar', d.isBar)
				localStorage.setItem('is_new', d.isNew)
				localStorage.setItem('is_sky_shop', d.isSkyShop)
			}
		}
	},
	methods: {
		...mapActions('departments', ['fetchMyDepartments']),
		...mapActions('zetReport', ['startSessionToDep', 'getCurrentXReport']),
		closeReturnModal() {
			this.returnComponentModal = false;
		},
		async humoClose() {
			try {
				this.loading = true

				const { data: response } = await FBoxService.humoClose(localStorage.getItem('ip_address'), localStorage.getItem('cash_id'))

				if (response) {
					this.$vs.notify({
						time: 1000,
						title: 'Успешно!',
						color: 'success',
						icon: 'close',
						position: 'top-right'
					});
				}
			} catch (error) {
				console.log(error)
				// if (error.request && error.request.response && error.request.response !== "") {
				// 	this.$bvModal.msgBoxOk(JSON.parse(error.request.response).message, {
				// 		size: 'sm',
				// 		centered: true,
				// 		hideHeader: true,
				// 		noCloseOnEsc: true,
				// 		okVariant: 'success',
				// 		noCloseOnBackdrop: true,
				// 		footerClass: 'bg-dager',
				// 		bodyClass: 'bg-dager h3 bold'
				// 	}).then(value => {
				// 	})
				// } else {
				// 	this.$bvModal.msgBoxOk(error.message, {
				// 		size: 'sm',
				// 		centered: true,
				// 		hideHeader: true,
				// 		noCloseOnEsc: true,
				// 		okVariant: 'success',
				// 		noCloseOnBackdrop: true,
				// 		footerClass: 'bg-dager',
				// 		bodyClass: 'bg-dager h3 bold'
				// 	}).then(value => {
				// 	})
				// }
			} finally {
				this.loading = false
			}
		},
		async closeAndPrintZReport(okEvent) {
			await PosService.getKkmSaleCount(localStorage.getItem('dep_id'), localStorage.getItem('cash_id')).then(async (res) => {
				if (res.data === 0) {
					okEvent.preventDefault();
					if (!this.fiscalData.id) {
						this.$vs.notify({
							title: 'Продажа не было...',
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
						return 0;
					}
					await this.getCurrentXReport(this.fiscalData.departmentId)
					let resFromFBox = null;
					let errMsgFromFBox = null;
					try {
						resFromFBox = await FBoxService.xAndZReportCloseOrPrint({
							ipAddress: this.fiscalData.ipAddress,
							data: this.currentReport.payments,
							closeZReport: true,
							salesEur: this.currentReport.salesEuro,
							totalEur: this.currentReport.totalWithDiscount - this.currentReport.totalRefundAmount,
							sellerName: this.currentReport.cashierFullName,
							cashboxName: this.currentReport.cashboxName,
							depName: this.currentReport.departmentName
						});
					} catch (e) {
						if (e.request && e.request.response) {
							let response = JSON.parse(e.request.response);
							errMsgFromFBox = response.message;
						}
					}
					if (resFromFBox && resFromFBox.data.is_success) {
						this.confirmEndSession = false
						this.zreport = true
					} else {
						let fbError = resFromFBox ? resFromFBox.data.error.message : (errMsgFromFBox ? errMsgFromFBox : 'XATOLIK: Iltimos, qayta urunib ko\'ring')
						this.$vs.notify({
							title: fbError,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					}
				} else {
					this.$vs.notify({
						title: 'Сначала отправьте все чеки',
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				}
			}).catch(er => {
				this.$vs.notify({
					title: er.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		xreportOpen() {
			if (!this.fiscalData.id) {
				this.$vs.notify({
					title: 'Пожалуста выберите кассу',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
				return 0;
			} else {
				localStorage.setItem('cash_id', this.fiscalData.id)
				this.xreport = true
			}
		},
		closeZreport() {
			this.zreport = false
			this.$router.go()
			if (TokenService.getUserRoles() == 'seller') {
				this.$store.dispatch('logout')
			}
		},
		closeXreport() {
			this.xreport = false
		},
		async toPos() {
			if (this.fiscalData.departmentId && this.fiscalData.id) {
				// 	await FBoxService.getInfoFiscal().then(res => {
				// 		if (res.data.is_success === true) {
				this.$router.push(`/point-of-sale/pos-v2/${this.fiscalData.departmentId}/${this.fiscalData.id}`)
				// 	} else {
				// 		this.$vs.notify({
				// 			title: res.data.error.message,
				// 			color: 'danger',
				// 			icon: 'close',
				// 			position: 'top-right'
				// 		});
				// 	}
				// }).catch(e => {
				// 	this.$vs.notify({
				// 		title: e.message,
				// 		color: 'danger',
				// 		icon: 'close',
				// 		position: 'top-right'
				// 	});
				// })
			} else {
				this.$vs.notify({
					title: 'Пожалуста выберите кассу',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
			}
		},
		logout() {
			this.$store.dispatch('logout')
		}
	},
	async created() {
		await FBoxService.getFiscalIpData().then(res => {
			this.fiscalData = res.data
		}).catch(e => {
			this.$vs.notify({
				title: e.message,
				color: 'danger',
				icon: 'close',
				position: 'top-right'
			});
		})
		// await this.fetchMyDepartments();
		// let dep = localStorage.getItem('department')
		// if (this.myDepartments.length === 1) {
		// 	this.selectedDepForSearch = this.myDepartments[0]
		// 	localStorage.setItem('department', JSON.stringify(this.myDepartments[0]))
		// } else if (dep) {
		// 	this.selectedDepForSearch = JSON.parse(dep)
		// } else {
		// 	let userDep = this.myDepartments.find(dep => dep.id == this.userDepId)
		// 	this.selectedDepForSearch = userDep ? Object.assign({}, userDep) : null
		// }
		// await this.fetchCashboxList();
	}
}
</script>

<style scoped></style>
